<template>

    <main class="temoignages-body-template">
        <article>
            <section class="text-right">
                <figure>
                    <img class="picture" v-if="item.picture" :src="require('../../assets/' + item.picture)" alt="">
                    <figcaption>
                        <p :class="item.color">AURÉLIE ORNON</p>
                        <p class="green">FORESTRY MANAGER

 <br />IN MARCHEPRIME (33)</p>
                    </figcaption>
                </figure>


                <p class="number" :class="item.color">
                  €76.1 billion 
                <p class="green uppercase semiBold">
                   AUM  by Groupama Asset Management  invested in SRI
                </p>


                <img class="icono w300" :src="require('../../assets/t7-2.jpg')">
                <p class="label green">
                    RESPONSIBLE INVESTMENT

                <p class="green uppercase semiBold">
                   An equity investment in France alongside Banque des Territoires in Predica Energies Durables (PED), it invests exclusively in French solar and wind energy generation.
                </p>

                <p class="label green">
                    PORPHYRE CLIMAT SEPTEMBRE 2019

                <p class="green uppercase semiBold">
                  The first unit-linked green debt security 100% committed to the energy transition
                </p>


            </section>

            <section>
                <svg class="quote" :class="item.color" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.8 42.61">
                    <path d="M59.8,0H45.59C39,11,34.91,18,33.43,20.83a17.92,17.92,0,0,0-2.17,8.26c0,7.57,6.36,13.52,14.34,13.52s14.2-6,14.2-13.52c0-5.28-2.7-9.2-8.11-11.5ZM28.55,0H14.21C7.57,11.09,3.65,18.13,2.16,21A17.49,17.49,0,0,0,0,29.09c0,7.57,6.22,13.52,14.2,13.52s14.2-6,14.2-13.52c0-5.28-2.7-9.2-8.11-11.5Z"/>
                </svg>
                <h2>Our forests offset the majority of Group carbon emissions, and are part of a wider virtuous process.</h2>
                <h1>   
                    <span>COMMITTING TO A </span>
					 <span><em :class="item.color">MORE RESPONSIBLE MODEL</em>  </span>
                    <span>OF FINANCE ALONGSIDE </span>
                    <span>AURÉLIE AND ALL</span>
					 <span><em :class="item.color">OUR PARTNERS</em>  </span>
                    
                </h1>


                <p>
                    Aurélie has worked at Groupama for 20 years. This daughter of foresters now has responsibility for the 6,700 hectares of the Gironde sector of Société Forestière Groupama. A major manager of forestry plantations in France, with <span class="marker" :class="item.color">a total portfolio of around 22,000 hectares</span>,
                    Groupama Immobilier has a remarkable heritage in landscape management. The historic roots of the Group are deep in the earth, and its Chairman Jean-Yves Dagès is himself closely involved as Chair of the Groupama Forest Committee. 
                    <br><br>
                    Aurélie is passionate about her work, which focuses on preparing roadmaps for forest management: marking trees to be felled or sold, tree cultivation, reforestation and bringing in tractors from external providers. 
                    <br><br>
                    She enjoys being part of a major group of companies like Groupama, especially since it allows her access to the kind of specialist expertise available at INRA, the French National Institute for Agricultural Research, for example.
                    <br><br>
                   At Groupama, we see value in forests. That’s because forest management is integral to a sustainable development policy built around a long-term commitment. “Today, there’s much more discussion around forests, but at Groupama, we began to change long before environmental concerns hit the headlines”, she says. “Our forests offset the majority of Group carbon emissions, and are part of a wider virtuous process”. Groupama’s certification under the Programme for the Endorsement of Forest Certification (PEFC) scheme overlays the Unified Management Plan designed and introduced to ensure sustainable management. It requires the Group to comply with a set of specifications and ensure the traceability of timber from forest to end user. 	
                </p>

                <a href="" class="link">
                    <svg class="link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 324">
                        <path d="M239,260v56a7.89,7.89,0,0,1-8,8H40A40.12,40.12,0,0,1,0,284V40A40.12,40.12,0,0,1,40,0H242c4,0,8,4,8,8V252a7.89,7.89,0,0,1-8,8Zm-16,16V260H40a23.69,23.69,0,0,0-24,24c0,14,10,24,24,24H223V292H37V276Zm11-31V16H40C26,16,16,26,16,40V253c7-5,14-8,24-8Z"/>
                        <path d="M197,64v61H52V64ZM183,78H67v33H183Z"/>
                    </svg>
                   <div class="link-content">
                        <p>To learn more about the facts that marked our year</p>
                        <p><span>DOWNLOAD</span> THE ANNUAL REPORT</p>
                    </div>
                </a>

            </section>
        </article>
    </main>


</template>

<script>

    export default {
        name: "TemoignageBody",
        props: ['item'],
        mounted() {

            window.removeEventListener('scroll', this.scroll)
            window.addEventListener('scroll', this.scroll)

        },
        methods: {
            scroll() {
                if(!document.querySelector('.temoignages-item-bar.active'))
                    return;

                if (this.isInViewport(document.querySelector('.temoignages-item-bar.active')))
                    document.querySelector('.temoignages-item-bar.active + .temoignages-item-content .close').style.opacity = 0;
                else
                    document.querySelector('.temoignages-item-bar.active + .temoignages-item-content .close').style.opacity = 1;
            },
            isInViewport(elem) {
                let bounding = elem.getBoundingClientRect();
                return (
                    bounding.top >= -document.querySelector('.temoignages-item-bar.active').clientHeight &&
                    bounding.left >= 0 &&
                    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            }
        }
    }
</script>
